import PropTypes from "prop-types";
// @mui
import { List, Stack } from "@mui/material";
//
import { StyledSubheader } from "./styles";
import NavList from "./NavList";
import { RoleBasedGuard, useAuthContext } from "../../../sections/auth";
import { upperCase } from "lodash";

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  sx: PropTypes.object,
  data: PropTypes.array,
};

export default function NavSectionVertical({ data, sx, ...other }) {
  const { user } = useAuthContext();

  return (
    <Stack sx={sx} {...other}>
      {/* Debug to know which environment */}
      {/* {user &&
        ["mark@ascendware.net", "abdul@ascendware.net"].includes(
          user?.email
        ) && (
          <div className=" bg-[#00000069] pl-[16px] pr-[12px] pb-[8px] pt-[8px] text-white m-2 rounded-full text-center">
            <small>Only Abdul & Mark can see this</small> <br />
            Env: {upperCase(process.env.REACT_APP_ENV)} <br />
          </div>
        )} */}
      {data.map((group) => {
        const key = group.subheader || group.items[0].title;
        return (
          <RoleBasedGuard key={key} roles={group.roles}>
            <List key={key} disablePadding sx={{ px: 2 }}>
              {group.subheader && (
                <StyledSubheader disableSticky>
                  {group.subheader}
                </StyledSubheader>
              )}

              {group.items.map((list) => (
                <NavList
                  key={list.title + list.path}
                  data={list}
                  depth={1}
                  hasChild={!!list.children}
                />
              ))}
            </List>
          </RoleBasedGuard>
        );
      })}
    </Stack>
  );
}
